import React, { useEffect, useRef, useState, FC } from "react";
import { Button, message } from "antd";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef, ISelectOption } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { getFormValidatorErrText } from "@/utils/utils"
import { YhBox } from "@/components/YhBox";
import { useWarehouseDetailModel } from "./warehouseDetailModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";

export const FormBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        editFormVal,
        updateEditFormVal,
        editWarehouse,
        getWarehouseOne
    } = useWarehouseDetailModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel(({ selectedNavId }) => [selectedNavId]);
    const { getSelectedDictOne, getTreeSelectOne } = useDictModel(() => []);
    const formRef = useRef<IYhFormRef>();

    useEffect(() => {
        getWarehouseOne(id);
    }, [])

    //清楚缓存
    useEffect(() => {
        return () => {
            !findNav("7-1-2") && updateEditFormVal(null);
        }
    }, [selectedNavId])

    //关闭当前页
    const onClose = () => {
        replaceNav(selectedNavId, "7-4");
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(val => {
            editWarehouse({ ...val, id }).then(res => {
                res && onClose();
                updateEditFormVal(null);
            })
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }, isFormItem: boolean = true) => {
        isFormItem && formRef.current?.setFieldsValue(val);
        updateEditFormVal(val)
    }

    //仓库类型
    const typeCodeChange = (value: string, option: ISelectOption) => {
        option && saveCache({ typeName: option.label, typeCode: option.value });
    }

    const onChange = (changedValues: { [key: string]: any }) => {
        saveCache(changedValues, false)
    }

    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "18px 77px 0 0", marginBottom: "10px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "仓库编码",
                fieldName: "code",
                disable: true,
                placeholder: "自动生成"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "仓库名称",
                fieldName: "name",
                rules: [{ required: true, message: "请输入仓库名称" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
            },{
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
            },{
                type: FormItemTypeEnum.Select,
                fieldLabel: "仓库类型",
                fieldName: "typeCode",
                onSelectChange: typeCodeChange,
                options: getSelectedDictOne(DictCodeEnmu.WAREHOUSE_TYPE),
                // rules: [{ required: true, message: "请选择仓库类型" }]
            },  {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系地址",
                fieldName: "address",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "从属门店",
                fieldName: "shopName",
                disable: true
            }, 
            
            //带出
            {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "仓库类型名称",
                fieldName: "typeName",
                hidden: true
            }

        ]
    };




    const stockEntryFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 8 },
        labelAlign: "right",
        formValues: editFormVal,
        onChange,
        boxs: [baseFormItem]
    }


    const action = <>
        {/* <YhAuth resCode={mode === "edit" ? ResourceAuthEnum.DATA_S_ED_SAVE : ResourceAuthEnum.DATA_S_AD_SAVE}> */}
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onSubmit}
            >保存</Button>
        {/* </YhAuth> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onClose}
        >取消</Button>
    </>;

    return (
        <>
            <YhBox title={`仓库${mode === "edit" ? "编辑" : "新增"}`} action={action} style={{ paddingBottom: "0px", marginBottom: "10px" }}></YhBox>
            <YhFormBox {...stockEntryFromConfig} />
        </>
    )
}